import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    myVendorInfo:{}
  },
  getters: {
    myVendorInfo (state) {
      return state.myVendorInfo;
    }
  },
  mutations: {
    updateState(state, payload) {
      state[payload.name] = payload.value
    }
  },
  actions: {
  }
});

export default store



// WEBPACK FOOTER //
// ./src/store.js